export default "__VITE_ASSET__C$XPb0Tu__"